import PropTypes from 'prop-types';
import editorTypeEnum from './visualEditorTypeEnum';

export const editorTypeProp = PropTypes.oneOf(Object.values(editorTypeEnum));
